import { useNavigate } from "react-router-dom";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Button from "@mui/material/Button";
import { useLanguage } from "../../i18n/LanguageContext";

export default function ResetButton({ path }) {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <Button
      onClick={() => {
        navigate({
          pathname: path,
        });
      }}
      startIcon={<RotateLeftIcon />}
      variant="outlined"
    >
      {t("timer.resetAll")}
    </Button>
  );
}
